import React, { useState } from 'react';
import PropTypes from 'prop-types';
import format from 'string-template';

import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import InputAdornment from '@mui/material/InputAdornment';

import {
  ContractMinimumValue,
} from '../../../utils/userContract';

import {
  Container,
  StyledInput,
} from './styles';
import texts from './texts.json';

const FeeInput = ({
  label,
  value,
  name,
  onChange,
  max: maxPercentage,
}) => {
  const [isOverridingFees, setIsOverridingFees] = useState(false);
  const [initialValue] = useState(value);

  const maxValue = maxPercentage !== undefined ? maxPercentage : initialValue;

  const handleCheckboxChange = (event) => {
    setIsOverridingFees(event.target.checked);
    if (!event.target.checked) {
      // Reset the value to its initial value when checkbox is unchecked (not overriding fees)
      onChange({ target: { name, value: initialValue } });
    }
  };

  const error = value > maxValue || value < ContractMinimumValue.FEE_PERCENTAGE;
  const helperText = (error && value > maxValue)
    ? format(texts.wrongPercentage, { value: maxValue })
    : texts.positiveNumber;

  return (
    <Container>
      <FormControlLabel
        control={(
          <Checkbox
            checked={isOverridingFees}
            onChange={handleCheckboxChange}
          />
        )}
        label={label}
      />
      <StyledInput
        size="small"
        value={value}
        name={name}
        onChange={onChange}
        type="number"
        disabled={!isOverridingFees}
        error={error}
        helperText={error && helperText}
        InputProps={{
          inputProps: {
            min: ContractMinimumValue.FEE_PERCENTAGE,
            max: maxValue,
          },
          endAdornment: (
            <InputAdornment position="end">%</InputAdornment>
          ),
        }}
        fullWidth
      />
    </Container>
  );
};

FeeInput.propTypes = {
  label: PropTypes.string,
  value: PropTypes.number,
  name: PropTypes.string,
  onChange: PropTypes.func,
  max: PropTypes.number,
};

FeeInput.defaultProps = {
  label: '',
  value: 0,
  name: '',
  onChange: () => {},
  max: undefined,
};

export default FeeInput;
